<template>
    <div>
        <component
            :is="componentName"
            :items="roles"
            :label="`${$root.defaultMandatoryAsteriks} ${$attrs.label} `"
            dense
            rounded
            item-text="name"
            item-value="id"
            append-icon="mdi-chevron-down"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
                <slot :name="slot" v-bind="scope"></slot>
            </template>
        </component>
    </div>
</template>

<script>
export default {
    props: {
        groups: {
            type: String,
            default: null,
        },
        componentName: {
            type: String,
            required: false,
            default: 'v-select',
        },
    },
    data() {
        return {
            roles: [],
            hidden: ['Device'],
        };
    },
    created() {
        this.loadRoles();
    },
    methods: {
        loadRoles() {
            axios.get(route('api.v1.roles.options', { active: 1, groups: this.groups })).then((response) => {
                this.roles = response.data.data;
            });
        },
    },
};
</script>

<style scoped></style>
